import { connect } from 'react-redux';
import { trackLink } from 'common/src/app/actions/trackingActions';
import LinkTracker from './LinkTracker';

export default connect(null, { trackLink })(LinkTracker);
